// Infinite scrolling
// let elem = document.querySelector('.container');


// if (typeof InfiniteScroll !== 'undefined') {
//   infScroll = new InfiniteScroll(elem, {
//     path: '.pagination__next',
//     append: '.post',
//     status: '.page-load-status',
//     hideNav: '.pagination',
//     scrollThreshold: 1000,
//     history: true
//   });
// } else {
//    console.log('Function not found');
// }


document.addEventListener('DOMContentLoaded', function () {
    let pageNum = 2;
    const currentCollection = window.location.pathname.replace(/\/page\/\d+/, '');

    const infScroll = new InfiniteScroll('.container', {
      path() {
        return `${currentCollection}?page=${pageNum++}`;
      },
      append: '.grid__item',
      status: '.page-load-status',
      history: false,
      hideNav: '.pagination',
    });
  });

// Open all external links in a new tab

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}
